export default __webpack_public_path__ + "static/media/social-studies.dab8ea85.png";